console.log("EMBROIDERY PREVIEW CAPTURE LOADED");

window.captureEmbroideryPreview = async function () {

  const previewContainer =
    document.querySelector(
      ".embroidery-preview-container"
    );

  if (!previewContainer) {

    console.error(
      "Embroidery preview container not found"
    );

    return null;

  }

  try {

    const renderedCanvas =
      await html2canvas(
        previewContainer,
        {
          backgroundColor: null,
          useCORS: true,
          allowTaint: true,
          scale: 2
        }
      );

    const previewImage =
      renderedCanvas.toDataURL(
        "image/png"
      );

    console.log(
      "EMB PREVIEW CREATED",
      previewImage.substring(0,100)
    );

    return previewImage;

  } catch(err) {

    console.error(
      "PREVIEW CAPTURE FAILED",
      err
    );

    return null;

  }

};